/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState, useImperativeHandle } from "react";
import { Gantt, HTMLHost } from "./shared/gantt.js";
import { EventBusRouter } from "./helpers/router.js";
import { template } from "./helpers/dom.js";
import "./shared/gantt.css";

export default function GanttComponent(props) {
  let gantt_container = useRef();

  const ws = useState(() =>({}))[0];
  const [widget, setWidget] = useState(null);
  const once = useRef(false);

  useImperativeHandle(props.api, () => ({
    getState: () => ws.api.getState(),
		getReactiveState: () => ws.api.getReactiveState(),
		getStores: () => ws.api.getStores(),
		exec: (name, data) => ws.api.exec(name, data),
		setNext: ev => ws.api.setNext(ev),
		intercept: (name, data) => ws.api.intercept(name, data),
		on: (name, handler) => ws.api.on(name, handler),
		detach: (name, handler) => ws.api.detach(name, handler),
    getTask: (id) => ws.api.getTask(id),
  }));

  useEffect(() => {
    const evs = new EventBusRouter((name, ev) => {
      const camelCase = name.replace(/-([a-z])/g, (match, letter) =>
        letter.toUpperCase(),
      );
      const eventName = "on" + camelCase[0].toUpperCase() + camelCase.slice(1);

      if (props[eventName]) return props[eventName](ev);
      return true;
    });

    let obj;
    const initProps = { ...props };
    if (initProps.taskTemplate && typeof initProps.taskTemplate  === "function") {
      initProps.taskTemplate =  template(initProps.taskTemplate, HTMLHost);
    }


    // if (initProps.columns){
    //   initProps.columns = [...initProps.columns];
    //   initProps.columns.forEach((col, i) => {
    //     col = initProps.columns[i] = {...col};
    //     if (col.cell && typeof col.cell === "function") col.cell = template(col.cell, CellHost)
    //   });
    // }

    
    const externalContext = new Map([
			["wx-theme", "willow"],
		]);

    obj = new Gantt({
      target: gantt_container.current,
      context: externalContext,
      props: {
        ...initProps,
        init: (a) => {
          ws.api = a;
          a.setNext(evs);
          if (props.init) props.init(a);
        },
      },
    });

    setWidget(obj);

    return () => {
      if (obj) try { obj.$destroy(); } catch (e) {}
      if (gantt_container.current) gantt_container.current.innerHTML = "";
    };
  }, []);

  const {
    taskTemplate,
    markers,
    taskTypes,
    tasks,
    selected,
    activeTask,
    links,
    scales,
    columns,
    start,
    end,
    lengthUnit,
    cellWidth,
    cellHeight,
    scaleHeight,
    readonly,
    cellBorders,
    editorShape,
    zoom,
    baselines,
    highlightTime
  } = props;
  useEffect(() => {
    if (!once.current) {
      once.current = true;
      return;
    }

    if (ws.api && widget) {
      // exclude init from props
      const { init, ...updateProps } = props;
      if (updateProps.taskTemplate && typeof updateProps.taskTemplate !== "string")
        updateProps.taskTemplate = template(updateProps.taskTemplate, HTMLHost);
      // if (updateProps.columns){
      //   updateProps.columns = [...updateProps.columns];
      //   updateProps.columns.forEach((col, i) => {
      //     col = updateProps.columns[i] = {...col};
      //     if (col.cell && typeof col.cell === "function") col.cell = template(col.cell, CellHost)
      //   });
      // }

      widget.$$set(updateProps);
    }
  }, [
    taskTemplate,
    markers,
    taskTypes,
    tasks,
    selected,
    activeTask,
    links,
    scales,
    columns,
    start,
    end,
    lengthUnit,
    cellWidth,
    cellHeight,
    scaleHeight,
    readonly,
    cellBorders,
    editorShape,
    zoom,
    baselines,
    highlightTime
  ]);

  return (
    <div
      className={
        (props.containerClassName ? " " + props.containerClassName : "")
      }
      ref={gantt_container}
      style={{ height: "100%", width: "100%" }}
    ></div>
  );
}
